import React from 'react'
import Header from '../component/Header/Header'
import FooterNew from '../component/FooterNew/FooterNew'
import ProcessCards from '../component/ProcessCards'

function Process() {
  return (
    <div>

        <Header/>

        <div className='w-100' >
            <img src='/images/creatives/process-hero-img.jpg' alt='hero' className='w-100' style={{maxHeight:"80vh"}}/>

        </div>

        <ProcessCards/>
        
        <FooterNew/>

    </div>
  )
}

export default Process